import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client
import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//GET NEIGHBORLIST
const QUERY_getSearchNeighbor = gql`
  query getSearchNeighbors(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getSearchNeighbors(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      label
      geometry_cords
      id
      name
      city
      state
      streetaddress
      zip
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      amenities
      curb
      others
      latitude
      longitude
      medianprice
      primaryschoolscore
      middleschoolscore
      highschoolscore
      nhfullname
      neighborhoodImages {
        imageurl
        thumbnailurl
      }
      cityImages {
        imageurl
      }
      nhsummary {
        summary
      }
      is_display_prod
      is_display_dev
      appreciation
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add NeighbourSearch Function

async function getSearchNeighbors(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getSearchNeighbor,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { getSearchNeighbors };
